import axios from 'axios';
// import { message } from 'antd';

const setupAxiosInterceptors = () => {
  const onRequestSuccess = (config) => config;
  const onResponseSuccess = (response) => {
    return response;
  };
  const onResponseError = (err) => {
    const { response } = err;
    // return Promise.reject(response);
    return response;
  };
  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export default setupAxiosInterceptors;
